import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [authError, setAuthError] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };

  const token = localStorage.getItem("token");

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/auth/users", {
        headers: {
          Authorization: token,
        },
      });
      setUsers(res.data);
    } catch (err) {
      console.error("Failed to fetch users", err);
      if (err.response && err.response.status === 401) {
        setAuthError(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const toggleStatus = async (userId, currentStatus, userEmail) => {
    const newStatus = !currentStatus;
    const confirmation = window.confirm(
      `Are you sure you want to set ${userEmail}'s status to ${
        newStatus ? "Active" : "Inactive"
      }?`
    );

    if (!confirmation) return;

    try {
      await axios.patch(
        `/api/auth/users/${userId}/status`,
        { active: newStatus },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      fetchUsers(); // Refresh data after update
    } catch (err) {
      console.error("Failed to update status", err);
    }
  };

  useEffect(() => {
    if (token) {
      fetchUsers();
    } else {
      setAuthError(true);
    }
  }, []);

  if (authError) {
    return (
      <div className="form-container mt-[100px] flex flex-col items-center justify-center min-h-[600px]">
        Unauthorized: Please log in to view users.
      </div>
    );
  }

  return (
    <div className="form-container mt-[100px] flex flex-col items-center justify-center min-h-[600px]">
      <div className=" flex justify-between max-w-[900px] min-w-[300px] w-full">
        <h2 className="text-2xl font-semibold mb-4">User Account Status</h2>{" "}
        <button
          onClick={handleLogout}
          className="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow"
        >
          Logout
        </button>
      </div>

      {loading ? (
        <div className="text-center py-6">
          <div className="animate-spin h-8 w-8 border-4 border-blue-400 border-t-transparent rounded-full mx-auto" />
          <p className="mt-2 text-sm text-gray-500">Loading users...</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
            <thead className="bg-gray-100 text-left">
              <tr>
                <th className="px-6 py-3 text-sm font-medium text-gray-700">
                  Email
                </th>
                <th className="px-6 py-3 text-sm font-medium text-gray-700">
                  Status
                </th>
                <th className="px-6 py-3 text-sm font-medium text-gray-700">
                  Toggle
                </th>
              </tr>
            </thead>
            <tbody className="text-gray-700">
              {users.map((user) => (
                <tr key={user._id} className="border-t hover:bg-gray-50">
                  <td className="px-6 py-4">{user.email}</td>
                  <td className="px-6 py-4">
                    <span
                      className={`px-2 py-1 rounded-full text-xs font-semibold ${
                        user.active
                          ? "bg-green-100 text-green-700"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      {user.active ? "active" : "inactive"}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() =>
                        toggleStatus(user._id, user.active, user.email)
                      }
                      className={`px-4 py-2 rounded text-white text-sm font-medium ${
                        user.active
                          ? "bg-yellow-500 hover:bg-yellow-600"
                          : "bg-blue-600 hover:bg-blue-700"
                      }`}
                    >
                      Set {user.active ? "Inactive" : "Active"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Users;
